import * as Switch from "@radix-ui/react-switch";
import { cn } from "../lib/cn.ts";

/**
 * Interruptor das telas Settings do Ofative.
 *
 * Ligado: trilha `#0074FF`, thumb branco. Desligado: trilha cinza.
 */

export interface ToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  "aria-label"?: string;
}

export function Toggle({
  checked,
  onCheckedChange,
  disabled = false,
  id,
  "aria-label": ariaLabel,
}: ToggleProps) {
  return (
    <Switch.Root
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        "relative h-[22px] w-[40px] shrink-0 rounded-full transition-colors duration-[var(--dream-duration-base)] ease-[var(--dream-ease-standard)]",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500",
        "disabled:opacity-50",
        checked ? "bg-brand-600" : "bg-[var(--color-surface-inset)]",
      )}
    >
      <Switch.Thumb
        className={cn(
          "block size-[18px] rounded-full bg-white shadow-[0_1px_2px_rgb(16_24_40_/_0.06),0_1px_3px_rgb(16_24_40_/_0.10)]",
          "translate-x-[2px] transition-transform duration-[var(--dream-duration-base)] ease-[var(--dream-ease-out)]",
          "data-[state=checked]:translate-x-[20px]",
        )}
      />
    </Switch.Root>
  );
}
